<template>
    <div class="about">
        <div class="title">
            <h1>About Me</h1>
            <h2>Hi! I'm a Full-Stack Web Developer with a focus on creating JavaScript, Vue3, PHP, and Laravel applications.</h2>
        </div>
        <div class="content">
            <div class="left">
                <p>My name is <strong>Aaron Gabriel Jimenez Fulgar</strong>, and I'm a dedicated web developer who places a lot of emphasis on making websites that are both user-friendly and visually pleasing. I have been working in the web development industry as a free-lancer since my 3rd year college, where I've had the chance to work on a variety of projects for diverse clients. I have experience with cutting-edge web technologies to create interactive and responsive websites. I can code and work both Front End and Back End development but I usually work and code in Back End because I'm more comfortable with it.</p>
                <br>
                <p>I founded and a former President of Alliance of Coders organization in Cebu Technological University - Danao Campus during my college years with a hundred plus more active members of BSIT. Also I am a musician I play bass guitar and during my rest in coding I love to read books that can make my brain relax from coding.</p>
                <div class="recommend">
                    <h1>Career Objectives</h1>
                </div>
                <p>To pursue a career path in prestigious international IT firms that will allow me to greatly improve my skills and make new connections, and to obtain a challenging position as an entry-level web developer, where I can utilize my technical skills, passion for coding, and creativity to create visually appealing and user-friendly websites. My goal is to work in a dynamic environment that encourages growth, learning and development, while contributing to the success of the company.</p>
                <div class="recommend">
                    <h1>Recommendations</h1>
                </div>
                <div class="recommends">
                    <div class="recs">
                        <div class="info">
                            <img src="../assets/avatar.webp" alt="">
                            <div>
                                <p><strong>Arnold Batac</strong></p>
                                <p>BSIT Chairman / I.T. Instructor 1</p>
                            </div>
                        </div>
                        <div class="text">
                            <p>Aaron and I work together during his internship. He has a good problem solving skills especially in web development. Also he is a good team player. He also has a strong understanding in web development architecture.</p>
                        </div>
                    </div>
                    <div class="recs">
                        <div class="info">
                            <img src="../assets/avatar.webp" alt="">
                            <div>
                                <p><strong>Jover Capuyan</strong></p>
                                <p>I.T. Instructor / I.T. Technician</p>
                            </div>
                        </div>
                        <div class="text">
                            <p>He has a talent in programming, we've been worked together in freelancing jobs creating programs/systems specially in web development and other personal programming matter.</p>
                        </div>
                    </div>
                    <div class="recs">
                        <div class="info">
                            <img src="../assets/avatar.webp" alt="">
                            <div>
                                <p><strong>Glenard Sarmiento</strong></p>
                                <p>I.T. Instructor</p>
                            </div>
                        </div>
                        <div class="text">
                            <p>He is a good programmer. He really know his code and work in web development. He is eager to learn new things and consistent to his work.</p>
                        </div>
                    </div>
                    <div class="recs">
                        <div class="info">
                            <img src="../assets/avatar.webp" alt="">
                            <div>
                                <p><strong>Alvin Kris Hermosilla</strong></p>
                                <p>I.T. Instructor</p>
                            </div>
                        </div>
                        <div class="text">
                            <p>Aaron is an exceptional web developer. His coding skills, attention to detail, and dedication to staying consistent making him an invaluable asset to any team. It's been a pleasure to know him, and I look forward for more successful things for him. Keep up the excellent work 👌.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="services">
                    <h3>Services</h3>
                    <p>Are you looking for a freelancer that can build you a Web Applications? maybe we can talk about it. I offer Web Application Development and Web Designs. You can <strong><router-link :to="{name: 'contact'}">contact</router-link></strong> me if you want me on your projects.</p>
                </div>
                <div class="tech-stack">
                    <h3>Tech Stack</h3>
                    <div class="tech-icons">
                        <div class="tech-icon">
                            <img src="../assets/html.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/css.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/tailwind.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/js.jpg" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/typescript.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/vue.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/php.svg" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/laravel.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/java.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/spring-boot.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/mysql.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/docker.png" alt="">
                        </div>
                        <div class="tech-icon">
                            <img src="../assets/aws.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>